// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#parent {
	position: relative;
	container-type: inline-size;
	container-name: parent;
}

.back {
	position: absolute;
	width: 100cqw;
	height: calc(1.238 * 100cqw);
}
#inside {
	position: absolute;
	top: 6cqw;
	left: 6cqw;
	width: 88cqw;
	height: calc(1.238 * 90cqw);
	text-align: center;
}

#priceHeadline {
	margin: calc(1.238 * 90cqw * 0.03) 0px;
	font-size: calc(1.238 * 90cqw * 0.04);
	color: black;
}

#priceImg {
	height: calc(1.238 * 90cqw * 0.9);
}

#wholeDoor {
	position: absolute;
	top: 6cqw;
	left: 6cqw;
	width: 88cqw;
	transform-origin: left;
	transition: transform 5s ease-in-out;
}

#wholeDoor.sweepStakeStateResultWin,
#wholeDoor.sweepStakeStateAddressInput {
	transform: perspective(100cqw) translateZ(0px) translateX(0px) translateY(0px) rotateY(-105deg);
}
#tuer {
	position: absolute;
	width: 88cqw;
}

#dreher {
	position: absolute;
	left: 6cqw;
	margin-top: 6cqw;
	transform: rotate(45deg);
	width: 75cqw;
}

#dreher.sweepStakeStateCheckCode {
	animation: rotation 0.5s linear infinite;
}

@keyframes rotation {
	from {
		transform: rotate(359deg);
	}

	to {
		transform: rotate(0deg);
	}
}

#numberFields {
	position: absolute;
	top: 90.5cqw;
	left: 5.5cqw;
	width: 76.5cqw;
	height: calc(1.238 * 100cqw * 0.11);
	display: flex;
	justify-content: space-between;
}

#lable {
	position: absolute;
	top: 75cqw;
	left: 30cqw;
	padding: 2cqw;
	text-align: center;
	font-size: calc(1.238 * 100cqw * 0.03);
	background-color: #007d93;
	border-radius: 3cqw;
	width: 24cqw;
	box-shadow: 4px 4px 34px rgba(0, 0, 0, 0.5) inset;
}
.numberfield {
	width: 21cqw;
	border-radius: 3cqw;
	color: white;
	text-align: center;
	padding: 5px;
	font-size: calc(1.238 * 100cqw * 0.065);
	border: 1cqw transparent solid;
	box-shadow: 4px 4px 34px rgba(0, 0, 0, 0.803294) inset;
	background-color: rgba(90, 90, 90, 1);
}

.numberfield.sweepStakeStateAddressInput {
	border: 1cqw yellow solid;
}

.numberfield.sweepStakeStateCheckCode {
	border: 1cqw yellow solid;
	animation: blink 1s linear infinite;
}
@keyframes blink {
	from {
		border: 1cqw yellow solid;
	}
	to {
		border: 1cqw transparent solid;
	}
}
.numberfield.sweepStakeStateResultNoWin {
	border: 1cqw red solid;
}

#lable.sweepStakeStateResultWin,
#lable.sweepStakeStateAddressInput {
	animation: hide 1ms 3.5s forwards;
	opacity: 1;
}

#dreher.sweepStakeStateResultWin,
#dreher.sweepStakeStateAddressInput {
	animation: hide 1ms 3.5s forwards;
	opacity: 1;
}

.numberfield.sweepStakeStateResultWin,
.numberfield.sweepStakeStateAddressInput {
	border: 1cqw green solid;
	animation: hide 1ms 3.5s forwards;
	opacity: 1;
}
@keyframes hide {
	to {
		opacity: 0;
	}
}
#lable.sweepStakeStateCodeInput {
	animation: show 1ms 1.5s forwards;
	opacity: 0;
}

#dreher.sweepStakeStateCodeInput {
	animation: show 1ms 1.5s forwards;
	opacity: 0;
}

.numberfield.sweepStakeStateCodeInput {
	animation: show 1ms 1.5s forwards;
	opacity: 0;
}
@keyframes show {
	to {
		opacity: 1;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/Tresor/Tresor.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,4BAA4B;AAC7B;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,YAAY;CACZ,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,sCAAsC;CACtC,qCAAqC;CACrC,YAAY;AACb;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,YAAY;CACZ,sBAAsB;CACtB,oCAAoC;AACrC;;AAEA;;CAEC,+FAA+F;AAChG;AACA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,gBAAgB;CAChB,wBAAwB;CACxB,YAAY;AACb;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC;EACC,yBAAyB;CAC1B;;CAEA;EACC,uBAAuB;CACxB;AACD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,cAAc;CACd,mCAAmC;CACnC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,sCAAsC;CACtC,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;CACZ,iDAAiD;AAClD;AACA;CACC,YAAY;CACZ,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,uCAAuC;CACvC,8BAA8B;CAC9B,sDAAsD;CACtD,qCAAqC;AACtC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,mCAAmC;AACpC;AACA;CACC;EACC,yBAAyB;CAC1B;CACA;EACC,8BAA8B;CAC/B;AACD;AACA;CACC,sBAAsB;AACvB;;AAEA;;CAEC,iCAAiC;CACjC,UAAU;AACX;;AAEA;;CAEC,iCAAiC;CACjC,UAAU;AACX;;AAEA;;CAEC,wBAAwB;CACxB,iCAAiC;CACjC,UAAU;AACX;AACA;CACC;EACC,UAAU;CACX;AACD;AACA;CACC,iCAAiC;CACjC,UAAU;AACX;;AAEA;CACC,iCAAiC;CACjC,UAAU;AACX;;AAEA;CACC,iCAAiC;CACjC,UAAU;AACX;AACA;CACC;EACC,UAAU;CACX;AACD","sourcesContent":["#parent {\n\tposition: relative;\n\tcontainer-type: inline-size;\n\tcontainer-name: parent;\n}\n\n.back {\n\tposition: absolute;\n\twidth: 100cqw;\n\theight: calc(1.238 * 100cqw);\n}\n#inside {\n\tposition: absolute;\n\ttop: 6cqw;\n\tleft: 6cqw;\n\twidth: 88cqw;\n\theight: calc(1.238 * 90cqw);\n\ttext-align: center;\n}\n\n#priceHeadline {\n\tmargin: calc(1.238 * 90cqw * 0.03) 0px;\n\tfont-size: calc(1.238 * 90cqw * 0.04);\n\tcolor: black;\n}\n\n#priceImg {\n\theight: calc(1.238 * 90cqw * 0.9);\n}\n\n#wholeDoor {\n\tposition: absolute;\n\ttop: 6cqw;\n\tleft: 6cqw;\n\twidth: 88cqw;\n\ttransform-origin: left;\n\ttransition: transform 5s ease-in-out;\n}\n\n#wholeDoor.sweepStakeStateResultWin,\n#wholeDoor.sweepStakeStateAddressInput {\n\ttransform: perspective(100cqw) translateZ(0px) translateX(0px) translateY(0px) rotateY(-105deg);\n}\n#tuer {\n\tposition: absolute;\n\twidth: 88cqw;\n}\n\n#dreher {\n\tposition: absolute;\n\tleft: 6cqw;\n\tmargin-top: 6cqw;\n\ttransform: rotate(45deg);\n\twidth: 75cqw;\n}\n\n#dreher.sweepStakeStateCheckCode {\n\tanimation: rotation 0.5s linear infinite;\n}\n\n@keyframes rotation {\n\tfrom {\n\t\ttransform: rotate(359deg);\n\t}\n\n\tto {\n\t\ttransform: rotate(0deg);\n\t}\n}\n\n#numberFields {\n\tposition: absolute;\n\ttop: 90.5cqw;\n\tleft: 5.5cqw;\n\twidth: 76.5cqw;\n\theight: calc(1.238 * 100cqw * 0.11);\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n#lable {\n\tposition: absolute;\n\ttop: 75cqw;\n\tleft: 30cqw;\n\tpadding: 2cqw;\n\ttext-align: center;\n\tfont-size: calc(1.238 * 100cqw * 0.03);\n\tbackground-color: #007d93;\n\tborder-radius: 3cqw;\n\twidth: 24cqw;\n\tbox-shadow: 4px 4px 34px rgba(0, 0, 0, 0.5) inset;\n}\n.numberfield {\n\twidth: 21cqw;\n\tborder-radius: 3cqw;\n\tcolor: white;\n\ttext-align: center;\n\tpadding: 5px;\n\tfont-size: calc(1.238 * 100cqw * 0.065);\n\tborder: 1cqw transparent solid;\n\tbox-shadow: 4px 4px 34px rgba(0, 0, 0, 0.803294) inset;\n\tbackground-color: rgba(90, 90, 90, 1);\n}\n\n.numberfield.sweepStakeStateAddressInput {\n\tborder: 1cqw yellow solid;\n}\n\n.numberfield.sweepStakeStateCheckCode {\n\tborder: 1cqw yellow solid;\n\tanimation: blink 1s linear infinite;\n}\n@keyframes blink {\n\tfrom {\n\t\tborder: 1cqw yellow solid;\n\t}\n\tto {\n\t\tborder: 1cqw transparent solid;\n\t}\n}\n.numberfield.sweepStakeStateResultNoWin {\n\tborder: 1cqw red solid;\n}\n\n#lable.sweepStakeStateResultWin,\n#lable.sweepStakeStateAddressInput {\n\tanimation: hide 1ms 3.5s forwards;\n\topacity: 1;\n}\n\n#dreher.sweepStakeStateResultWin,\n#dreher.sweepStakeStateAddressInput {\n\tanimation: hide 1ms 3.5s forwards;\n\topacity: 1;\n}\n\n.numberfield.sweepStakeStateResultWin,\n.numberfield.sweepStakeStateAddressInput {\n\tborder: 1cqw green solid;\n\tanimation: hide 1ms 3.5s forwards;\n\topacity: 1;\n}\n@keyframes hide {\n\tto {\n\t\topacity: 0;\n\t}\n}\n#lable.sweepStakeStateCodeInput {\n\tanimation: show 1ms 1.5s forwards;\n\topacity: 0;\n}\n\n#dreher.sweepStakeStateCodeInput {\n\tanimation: show 1ms 1.5s forwards;\n\topacity: 0;\n}\n\n.numberfield.sweepStakeStateCodeInput {\n\tanimation: show 1ms 1.5s forwards;\n\topacity: 0;\n}\n@keyframes show {\n\tto {\n\t\topacity: 1;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
